import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import WelcomeName from "../styled-ui-elements/WelcomeName";
import SignInSignOutButton from "./SignInSignOutButton";
const psnLogo:string = require('../../../../images/psnlogo.svg').default;
import { Link as RouterLink } from "react-router-dom";
import { Stack } from "@mui/material";
import { EditableLocationLabel } from '../styled-ui-elements/EditableLocationLabel';

const NavBar = () => {
    return (
        <div style={{ flexGrow: 1 }}>
            <AppBar position="fixed" sx={{zIndex:(theme)=>theme.zIndex.drawer + 1}}>
                <Toolbar>
                    <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%' padding={1}>
                        <Stack direction='row' gap={1}>
                            <EditableLocationLabel />
                        </Stack>
                        <a href={'/'}><img src={psnLogo} alt='logo'/></a>
                        <Stack direction='row' gap={1}><WelcomeName /><SignInSignOutButton /></Stack>
                    </Stack>
                </Toolbar>
            </AppBar>

        </div>
    );
};

export default NavBar;